import React from "react"
import {Box, FormControl, FormLabel, Radio, RadioGroup} from "@mui/material"
import {getOptions} from "../../misc/widget-functions"
import styled from "@emotion/styled"
import InfoIcon from "../../components/general/infoIcon"

export const widgetRadioButtonGroupPrototype = [
    {
        key: "direction",
        type: "SELECT",
        label: "Richtung",
        size: 3,
        options: [
            {
                value: "ROW",
                label: "Nebeneinander",
            },
            {
                value: "COLUMN",
                label: "Untereinander",
            },
        ],
    },
]

const BoxWrapper = styled(Box)(({theme}) => theme.RADIOBUTTONGROUP)

const RadiobuttonGroupWidget = ({
    widget,
    value,
    onValueChange,
    triggerAction,
}) => {
    const options = getOptions(widget)
    const handleChange = (event) => {
        onValueChange(event.target.value)
    }

    const handleClick = (newValue) => {
        onValueChange(newValue)
    }
    return (
        <FormControl fullWidth>
            {widget.text && <FormLabel>{widget.text}</FormLabel>}
            <RadioGroup
                row={widget.direction === "ROW"}
                value={value ?? options?.[0]?.value}
                onChange={handleChange}
                sx={{
                    gap: 1,
                    width: "100%",
                }}>
                {options.map((option, key) => {
                    const isActive = value !== null && value !== undefined ?
                        value === option.value : options?.[0]?.value === option.value

                    return (
                        <BoxWrapper
                            key={option.value || key}
                            onClick={() => handleClick(option.value)}
                            sx={(theme) => ({
                                width:
                                    widget.direction === "ROW"
                                        ? "auto"
                                        : "100%",
                                flex:
                                    widget.direction === "ROW"
                                        ? "1 1 auto"
                                        : "none",
                                backgroundColor: isActive
                                    ? theme.RADIOBUTTONGROUP.borderColorActive
                                    : "inherit",
                                minHeight: "48px",
                                padding: "8px 12px",
                                gap: 1,
                                marginBottom: "12px",

                                "&:last-child": {
                                    marginBottom:
                                        widget.direction === "ROW" ? "12px" : 0,
                                },
                            })}>
                            <Box
                                display="flex"
                                alignItems="center"
                                flex={1}
                                gap={1}>
                                <Radio
                                    checked={isActive}
                                    value={option.value}
                                    sx={{padding: 1}}
                                />
                                <span
                                    style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}>
                                    {option.label}
                                </span>
                            </Box>

                            {option.infoText && (
                                <Box
                                    display="flex"
                                    alignItems="center">
                                    <InfoIcon infoText={option.infoText} />
                                </Box>
                            )}
                        </BoxWrapper>
                    )
                })}
            </RadioGroup>
        </FormControl>
    )
}

export default RadiobuttonGroupWidget
